import script from "./FormButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormButton.vue?vue&type=script&setup=true&lang=ts"

import "./FormButton.vue?vue&type=style&index=0&id=2af0bd6a&lang=scss"

const __exports__ = script;

export default __exports__